/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { User } from '../models/User';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Fetches basic information about the user based on the user slug. This request is used before sending a user an e-mail with a link containing a token to authenticate on the site.
     * @param slug
     * @returns any Default Response
     * @throws ApiError
     */
    public authGetUser(
        slug: string,
    ): CancelablePromise<{
        slug: string;
        name: string;
        emails: Array<string>;
        signedIn: boolean;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/auth/{slug}',
            path: {
                'slug': slug,
            },
            errors: {
                404: `Default Response`,
            },
        });
    }
    /**
     * Send the user an e-mail with a token to validate the session.
     * @param requestBody
     * @returns any Default Response
     * @throws ApiError
     */
    public authPostToken(
        requestBody: {
            email?: string;
            slug?: string;
            redirect?: string;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Accepts a token, verifies it, and sets a cookie to permit further requests.
     * @param requestBody
     * @returns any Default Response
     * @throws ApiError
     */
    public authValidateToken(
        requestBody: {
            token: string;
        },
    ): CancelablePromise<{
        user: User;
        redirect?: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Default Response`,
            },
        });
    }
    /**
     * @returns User Default Response
     * @throws ApiError
     */
    public authGetCurrentUser(): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/auth/current_user',
            errors: {
                404: `Default Response`,
            },
        });
    }
    /**
     * @returns any Default Response
     * @throws ApiError
     */
    public authLogout(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/auth/logout',
        });
    }
}
